export default [
  {
    name: "Birgittasalen, HS",
    id: "00161871-691c-420e-8929-68abef974c9b",
  },
  {
    name: "Fasanen",
    id: "47f748fc-9fe1-423e-a515-584f327af0c5",
  },
  {
    name: "Ejdern",
    id: "b19fef21-eafe-4d1a-886b-dc901fe65bad",
  },
  {
    name: "Tranan",
    id: "493da18b-07b4-462e-a236-ddd7fd49c67d",
  },
  {
    name: "Staren",
    id: "08d7346c-8d8d-4150-b851-509b1cf20484",
  },
  {
    name: "Lärkan",
    id: "73b0b569-15f2-4430-9616-c72f26ef0fa6",
  },
  {
    name: "Tjädern",
    id: "e0d922af-3af9-46c7-b370-a94b3e480284",
  },
  {
    name: "Svalan",
    id: "3afc1b67-4b85-4499-ae22-d4331b4dd2f7",
  },
  {
    name: "Orren",
    id: "ef210c04-0e5e-4719-9f4a-a955cff112b4",
  },
]; /* .map(({ name, id }) => ({
  name,
  id,
  locationId: locations.campusUS.house240.id
}))
 */
